import { createDateRange, DateRange } from '../DateRange';
import { OwaDate, startOfDay } from 'owa-datetime';
/**
 * This function returns new start and end time based on the days duration change
 */
export default function getDatesOnDurationChanged(
    prevStartDate: OwaDate,
    durationInDays: number
): DateRange | null {
    if (prevStartDate && durationInDays != null) {
        return createDateRange(startOfDay(prevStartDate), durationInDays + 1);
    }
    return null;
}
